import React, { useState, useEffect } from "react";
import Layout from '../pages/Layout';
import Advertise from "../pages/Advertise";

const Aht = () => {
  // State variables for AHT calculation
  const [totalTalkTime, setTotalTalkTime] = useState(0); // Total talk time
  const [totalHoldTime, setTotalHoldTime] = useState(0); // Total hold time
  const [afterCallWorkTime, setAfterCallWorkTime] = useState(0); // Total after-call work time
  const [numberOfCalls, setNumberOfCalls] = useState(0); // Number of calls handled
  const [aht, setAht] = useState(0); // Calculated AHT

  // Event handlers to update state values
  const handleTalkTimeChange = (e) => setTotalTalkTime(parseFloat(e.target.value) || 0);
  const handleHoldTimeChange = (e) => setTotalHoldTime(parseFloat(e.target.value) || 0);
  const handleAfterCallWorkChange = (e) => setAfterCallWorkTime(parseFloat(e.target.value) || 0);
  const handleNumberOfCallsChange = (e) => setNumberOfCalls(parseFloat(e.target.value) || 0);

  // useEffect hook to calculate AHT when any input changes
  useEffect(() => {

    if (numberOfCalls > 0) {
      const calculatedAht = (totalTalkTime + totalHoldTime + afterCallWorkTime) / numberOfCalls;
      setAht(calculatedAht);
    } else {
      setAht(0);
    }

    // This will initialize or reinitialize all popovers on the page whenever the component renders
    const popoverTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="popover"]')
    );

    // Clean up any existing popover instances
    popoverTriggerList.forEach((popoverTriggerEl) => {
      const popover = window.bootstrap.Popover.getInstance(popoverTriggerEl); // Check if instance already exists
      if (popover) {
        popover.dispose(); // Dispose of existing popover
      }
    });

    // Re-initialize popovers
    popoverTriggerList.forEach((popoverTriggerEl) => {
      new window.bootstrap.Popover(popoverTriggerEl); // Re-initialize popovers
    });


  }, [totalTalkTime, totalHoldTime, afterCallWorkTime, numberOfCalls]);

  return (
    <Layout title="Average Handle Time (AHT) Calculator" path="aht">
      <section className="section-padding" id="aht-calculator">
        <div className="container mt-5">
          <div className="row">
            {/* AHT Calculator Form */}
            <div className="col-lg-9 col-md-8 mb-4">
              <div
                className="p-4 border rounded shadow"
                style={{ border: "1px solid black" }}
              >
                <h3 className="text-center mb-4">Average Handle Time (AHT) Calculator</h3>
                <div className="container">
                  <div className="row gy-3">
                    {/* Total Talk Time Input */}
                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="talkTime" className="form-label">
                        Total Talk Time (minutes)
                        <span
                    className="ms-2 text-muted"
                    data-bs-toggle="popover"
                    data-bs-html="true"
                    data-bs-placement="top"
                    data-bs-content="<strong>Talk Time:</strong> The total time spent by an agent speaking with a customer."
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-info-circle"></i>
                  </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="talkTime"
                        placeholder="Enter total talk time"
                        value={totalTalkTime || ""}
                        onChange={handleTalkTimeChange}
                      />
                    </div>

                    {/* Total Hold Time Input */}
                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="holdTime" className="form-label">
                        Total Hold Time (minutes)
                        <span
                    className="ms-2 text-muted"
                    data-bs-toggle="popover"
                    data-bs-html="true"
                    data-bs-placement="top"
                    data-bs-content="<strong>Hold Time:</strong> The total time a customer spends on hold during a call."
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-info-circle"></i>
                  </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="holdTime"
                        placeholder="Enter total hold time"
                        value={totalHoldTime || ""}
                        onChange={handleHoldTimeChange}
                      />
                    </div>

                    {/* After-Call Work Input */}
                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="afterCallWork" className="form-label">
                        Total After-Call Work (minutes)
                        <span
                    className="ms-2 text-muted"
                    data-bs-toggle="popover"
                    data-bs-html="true"
                    data-bs-placement="top"
                    data-bs-content="<strong>After-Call Work:</strong> The time spent by an agent on activities like logging call information after a call."
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-info-circle"></i>
                  </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="afterCallWork"
                        placeholder="Enter total after-call work"
                        value={afterCallWorkTime || ""}
                        onChange={handleAfterCallWorkChange}
                      />
                    </div>

                    {/* Number of Calls Input */}
                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="numberOfCalls" className="form-label">
                        Number of Calls Handled
                        <span
                    className="ms-2 text-muted"
                    data-bs-toggle="popover"
                    data-bs-html="true"
                    data-bs-placement="top"
                    data-bs-content="<strong>Calls Handled:</strong> The total number of calls that the agent has managed."
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-info-circle"></i>
                  </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="numberOfCalls"
                        placeholder="Enter number of calls"
                        value={numberOfCalls || ""}
                        onChange={handleNumberOfCallsChange}
                      />
                    </div>
                  </div>

                  {/* Result Section */}
                  <div className="mt-4">
                    <div className="p-3 text-center">
                      <h6>
                        Average Handle Time (AHT):{" "}
                        <span className="fw-bold ms-3">
                          {aht === 0 ? "0.00" : aht.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} minutes
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Advertisement Section */}
            <Advertise />
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="introduction-section" id="introduction">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="p-5">
                <h3 className="text-center mb-5">
                  Introduction to the Average Handle Time (AHT) Calculator
                </h3>

                {/* What is an AHT Calculator? */}
                <h4 className="mt-3 mb-3">What is an Average Handle Time (AHT) Calculator?</h4>
                <p>
                  The **Average Handle Time (AHT) Calculator** is a tool designed to measure the average time taken to resolve a customer query or issue. It takes into account the total talk time, hold time, and after-call work, divided by the number of calls handled.
                </p>

                {/* Why Use an AHT Calculator? */}
                <h4 className="mt-4 mb-3">Why Use an Average Handle Time (AHT) Calculator?</h4>
                <p>
                  Using this calculator helps identify inefficiencies in call handling processes and supports improvements in customer support performance. It also helps in workforce scheduling and agent training.
                </p>

                {/* Benefits of Using an AHT Calculator */}
                <h4 className="mt-4 mb-3">Benefits of Using an AHT Calculator</h4>
                <ul>
                  <li><strong>Improves Customer Support Efficiency:</strong> AHT helps pinpoint areas where support processes can be optimized.</li>
                  <li><strong>Identifies Areas for Process Improvement:</strong> High AHT values can indicate issues requiring additional training or process changes.</li>
                  <li><strong>Supports Workforce Scheduling and Training:</strong> Understanding AHT helps allocate resources effectively and design targeted training programs.</li>
                </ul>

                {/* Suitable For */}
                <h4 className="mt-4 mb-3">Who Should Use an Average Handle Time (AHT) Calculator?</h4>
                <p>
                  This calculator is ideal for:
                </p>
                <ul>
                  <li><strong>Call Centers:</strong> Helps measure and improve agent efficiency.</li>
                  <li><strong>Customer Service Teams:</strong> Tracks performance metrics for better customer satisfaction.</li>
                  <li><strong>Telecommunications:</strong> Supports service quality monitoring and process optimization.</li>
                </ul>

                {/* Additional Questions */}
                <h4 className="mt-4 mb-3">What is a good AHT value?</h4>
                <p>
                  A good AHT value depends on the industry and the complexity of customer queries. Generally, lower AHT indicates higher efficiency, but it should not compromise customer satisfaction.
                </p>

                <h4 className="mt-4 mb-3">How can I improve AHT?</h4>
                <p>
                  To improve AHT, focus on agent training, streamline call handling processes, and leverage technology like customer relationship management (CRM) systems to reduce hold and after-call work times.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Aht;
